var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('background-music',{ref:"bg_music",attrs:{"src":"https://cdn.qqbaidu.xyz/game51-2/audios/bg_music.mp3"}}),_c('we-chat',{on:{"ready":_vm.onWeChatReady}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }